<template>
    <div class="chat-input--wrapper">
        <textarea
                @keyup="onkeyup"
                @keyup.enter.exact.prevent
                @keyup.enter.exact="onSend"
                @focus="onFocus"
                class="chat-input--input"
                v-model="text"
                :placeholder="$t('typeAMessage')"
                @input="oninput"
                ref="textAreaInput"
        ></textarea>
        <div @click="onSend" class="chat-input--send">
            <img
                 src="@/assets/send-button.svg">
        </div>
        <div class="chat_incomming_message"
             v-if="thread.incomming"
        >
            <span>{{ thread.incomming.userName }}  {{ $t('isTyping') }} </span>
            <dot-loader size="4px"></dot-loader>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import DotLoader from './DotLoader'
import { SET_DRAG_MESSAGE } from '../constants/mutation-types'
import { appType } from "../constants/constants"

export default {
  name: 'ChatInput',
  components: {
    DotLoader
  },
  data () {
    return {
      text: '',
      isSentImcomming: false
    }
  },
  computed: {
    ...mapGetters({
      thread: 'currentThread',
      threads: 'threads',
      isConnectFail: 'isConnectFail',
      isOpenChat: 'isOpenChat'
    }),
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  created () {
    this.text = this.thread.dragMessage || ''
  },
  mounted () {
      this.oninput()
  },
  methods: {
    ...mapActions({
      sendMessage (dispatch) {
        const { thread } = this
        const textTrim = this.text.trim()
        if (textTrim) {
          dispatch('sendMessage', {
            text: textTrim,
            id: thread.id
          })
        }
        this.text = ''
      }
    }),
    onkeyup () {
      const { thread, userInfo } = this
      const textTrim = this.text.trim()
      if (textTrim.length > 0) {
        if (!this.isSentImcomming) {
          this.$store.dispatch('incommingMessage', {
            roomId: thread.id,
            userId: userInfo.userId,
            userName: userInfo.userName,
            status: 1
          })
          this.isSentImcomming = true
        }
      }
      if (textTrim.length === 0) {
        if (this.isSentImcomming) {
          this.$store.dispatch('incommingMessage', {
            roomId: thread.id,
            userId: userInfo.userId,
            userName: userInfo.userName,
            status: 0
          })
          this.isSentImcomming = false
        }
      }
    },
    onFocus () {
      const { thread } = this

        this.$store.dispatch('readMessage', {
            roomId: thread.id
        })
    },
    oninput () {
        this.$refs.textAreaInput.style.height = '0px'
        this.$refs.textAreaInput.style.height = (this.$refs.textAreaInput.scrollHeight - 10) +'px'
    },
    onSend () {
      this.sendMessage()
      this.$refs.textAreaInput.style.height = '0px'
      this.isSentImcomming = false
    }
  },
  watch: {
    'thread.lastMessage': function () {
      let isSendRead = false
      if (document.activeElement === this.$refs.textAreaInput) {
          isSendRead = true
      } else if (this.isOpenChat) {
          isSendRead = true
      }
      if (isSendRead) {
        const { thread } = this
        setTimeout( () => {
            if (thread.unreadCount > 0 && thread.id > 0) {
                this.$store.dispatch('readMessage', {
                    roomId: thread.id
                })
            }
        }, 400)
      }
    },
    'thread.id': function (newVal, oldVal) {
      const oldThread = this.threads[oldVal]
      if (oldThread) {
        this.$store.commit(SET_DRAG_MESSAGE, {id: oldVal, text: this.text})
      }
      this.text = this.thread.dragMessage || ''
      this.$refs.textAreaInput.focus()
    },
    'isConnectFail': function () {
      this.$store.commit(SET_DRAG_MESSAGE, {id: this.thread.id, text: this.text})
    },
    'isOpenChat': function (val) {
        if (val && this.$appType === appType.FMS) {
            const refs = this.$refs
            setTimeout( () => {
                refs.textAreaInput.focus()
            }, 500)
        }
     }
  }
}
</script>

<style lang="scss">
.chat-input--wrapper {
    width: 90%;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
    .chat-input--input {
        /*height: 42px;*/
        min-height: 42px;
        max-height: 150px;
        width: 100%;
        margin: 0;
        border: 1px solid lightgray;
        border-radius: 20px;
        flex: 1 0 auto;
        padding: 10px 42px 6px 15px;
        box-sizing: border-box;
    }
    .chat-input--send {
        flex: 0 0 auto;
        position: absolute;
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 5px;
        top: 2px;
        img {
            width: 60%;
            height: 60%;
            object-fit: cover;
            margin-left: 4px;
        }
    }
    .chat_incomming_message {
        position: absolute;
        bottom: 100%;
        left: 10px;
        display: flex;
        align-items: center;
        font-size: 13px;
    }
}
.chat-input--send:hover {
    color: #fff;
}
</style>
